import React from "react";
import { newsList } from "../data/news/NewsList";
import 'holderjs';
import { Col, Container, Row, Image } from "react-bootstrap";
import { Link } from "react-router-dom";

function NewsList() {
    return <Container className="">
        {newsList.map((value, index) => {
            if (value.isPublished) return <NewsItem key={index} title={value.title} description={value.shortDescription} publishDate={value.publishDate.toISOString().slice(0, 10)} path={value.path} />
        })}
    </Container >
}
export default NewsList;

type NewsItemProps = {
    publishDate: String,
    title: string,
    description: string
    path: string
}

//Render a news Item
export function NewsItem({ publishDate, description, title, path }: NewsItemProps) {
    return <Row className="pt-3 pb-3 news-item">
        <Col md="2" >{publishDate}</Col>
        <Col md="auto">
            <Row>
                <Col><Link to={path}>{title}</Link></Col>
            </Row>
            <Row><Col>{description}</Col></Row>
        </Col>
    </Row>;
}